"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_SEARCH_FIREBASE_IDENTITIES_BY_NAME = exports.MAX_SEARCH_FIREBASE_IDENTITIES = exports.PER_CONTRIBUTOR_ALLOWED_ROUNDING_ERROR = exports.TEST_CAPTURED_EMAILS_LOG_PATH = exports.DB_ROUNDING_NUM_DECIMALS = exports.USER_ROUNDING_NUM_DECIMALS = exports.LAST_MONTH_DATE_DICT = exports.OLDEST_SUPPORTED_QRE_PYR_YEAR = exports.COMMON_CONSTANTS = exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS_BEFORE_2023 = exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS = exports.US_COUNTRY_CODE = void 0;
const MS_IN_DAY = 1000 * 60 * 60 * 24;
const MS_IN_YEAR = MS_IN_DAY * 365;
const STATES = [
    'AL',
    'AK',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'MP',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];
exports.US_COUNTRY_CODE = 'US';
exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS = 50000000;
exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS_BEFORE_2023 = 25000000;
exports.COMMON_CONSTANTS = {
    SENTRY_ORG_SLUG: 'neo-tax',
    NUMBER_OF_MONTHLY_SUBSCRIPTION_ITERATIONS: 12,
    NUMBER_OF_QUARTERLY_SUBSCRIPTION_ITERATIONS: 4,
    NUMBER_OF_SEMI_ANNUAL_SUBSCRIPTION_ITERATIONS: 2,
    NUMBER_OF_ONE_TIME_SUBSCRIPTION_ITERATIONS: 1,
    OUTDATED_VERSION_ERROR_NAME: 'OutdatedVersion',
    MS_IN_DAY,
    MS_IN_YEAR,
    STATES,
    MAX_RD_PAYROLL_TAX_CREDIT_CENTS: exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS,
    MAX_RD_PAYROLL_TAX_CREDIT_CENTS_BEFORE_2023: exports.MAX_RD_PAYROLL_TAX_CREDIT_CENTS_BEFORE_2023,
};
exports.OLDEST_SUPPORTED_QRE_PYR_YEAR = 1994;
exports.LAST_MONTH_DATE_DICT = {
    '1': '31',
    '2': '28',
    '3': '31',
    '4': '30',
    '5': '31',
    '6': '30',
    '7': '31',
    '8': '31',
    '9': '30',
    '10': '31',
    '11': '30',
    '12': '31',
};
// RED: if you change this value, then you must change the sum_qualifying_amount_cents_finalfunc function in the database
/**
 * One order of magnitude less than the DB rounding (see rd-expense-project.entity.ts), to allow for some rounding error when aggregating
 *
 * Example:
 *
 * ## Setup:
 * - Project A
 * - Project A has 3 months with ticket's with effort m1, m2, and m3
 * - Assume we use simple averaging of the allocation percentage in those 3 months to get the period total allocation
 * - Assume DB_ROUNDING_NUM_DECIMALS = 2 and USER_ROUNDING_NUM_DECIMALS = 0
 *
 * ## Scenario:
 * 1. User sets the total period allocation to 100%
 * 2. We convert that into a per-month allocation percent of 100/3, which rounded using DB_ROUNDING_NUM_DECIMALS is 33.33%
 * 3. We then re-aggregate this per-month allocation percentage to get the total period allocation percentage of 99.99%,
 *   but before displaying to the user, we round to USER_ROUNDING_NUM_DECIMALS = 0 to get 100%.
 *
 * This example shows how using a two layer rounding system can help minimize rounding errors when using transformations that
 * have inherent rounding errors, such as division.
 */
exports.USER_ROUNDING_NUM_DECIMALS = 0;
exports.DB_ROUNDING_NUM_DECIMALS = 8; // 2 sig. fig. less than PMAs
// JSONL sink for emails sent in LOCAL/TEST envs. The server appends one line per
// capturable email; Cypress tasks read the most recent matching line to drive flows
// that depend on the link end-to-end (the invitee/verifier can't open a real email
// in test). Both producer (server) and consumer (cypress.config.js) must agree on
// this path, which is why it lives in @common rather than being duplicated.
exports.TEST_CAPTURED_EMAILS_LOG_PATH = '/tmp/neo-tax-captured-emails.jsonl';
// RED: if this logic changes, then make sure to update the sum_qualifying_amount_cents_finalfunc function in the database
/**
 * The maximum allowed rounding error per contributor when summing up the allocation percentages.
 */
exports.PER_CONTRIBUTOR_ALLOWED_ROUNDING_ERROR = 1 / 10 ** (exports.DB_ROUNDING_NUM_DECIMALS - 1);
// How many matching addresses the Identity Platform search considers, and so the most rows it can return.
// Shared because the caller pages the results itself and has to say when it is showing a truncated set —
// a number kept in two places would eventually disagree about when that is.
exports.MAX_SEARCH_FIREBASE_IDENTITIES = 500;
// Small because producing it scores every account in the project — Identity Platform indexes no name.
exports.MAX_SEARCH_FIREBASE_IDENTITIES_BY_NAME = 25;
